module.exports = __webpack_public_path__ + "img/icon-delete-red.4ced065a.svg";